import { useContext } from "react";

import { css, CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import TableContext from "context/table/tableContext";
import { RectangleLoader } from "shared";

import { FilterSeparatorProps } from "./types";

const FilterSeparator = ({ width, height }: FilterSeparatorProps) => {
    const { gray300 } = colors;

    const { isInitialLoading } = useContext(TableContext);

    const sharedStyles: CSSObject = {
        alignSelf: "flex-start",
        margin: "0 16px"
    };

    return isInitialLoading ? (
        <RectangleLoader
            width={width}
            height={height}
            customStyle={sharedStyles}
        />
    ) : (
        <div
            css={css({
                width,
                height,
                background: gray300,
                ...sharedStyles
            })}
        />
    );
};

export default FilterSeparator;
